module.exports = __webpack_public_path__ + "media/images/flags/au-a9157abccd81a6a9b9e178ac9fb1344e.svg";